<template>
  <div style="min-height:60px">
    <div :class="HeadLineFixed?'HeadFixed':'line_wrap'" id="HeadLine">
      <div class="wrap">
        <div class="logo">
          <a href="/">
            <img src="../assets/logo2.png" style="width: 60px;height: 30px;">
          </a>
          <div style="font-size: 22px;color: rgb(235, 92, 1);margin-left: 20px;font-weight: bold;">成都云处方科技有限责任公司</div>
        </div>
        <Menu mode="horizontal" :theme="theme1" :active-name="active_item">
          <MenuItem name="Home" :to="{name:'Home',path:'/',query: {}}">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          首页
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </MenuItem>

          <MenuItem name="DownLoad" :to="{name:'DownLoad',path:'/DownLoad',query: {}}">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          下载
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </MenuItem>
          <MenuItem name="About" :to="{name:'About',path:'/About',query: {}}">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          关于我们
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </MenuItem>
          <MenuItem name="Pros" :to="{name:'Pros',path:'/Pros',query: {}}">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          推荐产品
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </MenuItem>
          <MenuItem name="Case" :to="{name:'Case',path:'/Case',query: {}}">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          案例展示
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </MenuItem>
          <MenuItem name="News" :to="{name:'News',path:'/News',query: {}}">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          新闻资讯
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </MenuItem>
          <a href="https://smis.cn/smiswebuser/#/">
            <MenuItem name="申请试用" to="">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            申请试用
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </MenuItem>
          </a>

          <!-- <MenuItem name="User" :to="{path:'/User',query: {}}">
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              个人中心
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                         </MenuItem>                                                                                                  -->
        </Menu>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      theme1: 'light',
      active_item: 'Home',
      HeadLineFixed: false,
    }
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: 'handleRouteChange',
  },
  created: function () {
    this.active_item = this.$route.name
    this.handleRouteChange()
  },
  mounted: function () {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll: function () {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      var offsetTop = 300
      if (scrollTop > offsetTop) {
        this.HeadLineFixed = true
      } else {
        this.HeadLineFixed = false
      }
    },
    handleRouteChange: function () {
      var token = localStorage.token
      var UserInfo = localStorage.UserInfo
      if (token || UserInfo) {
        this.$store.commit('toLogInState', JSON.parse(UserInfo).Phone)
      } else {
        this.$store.commit('toLogoutState', '登录')
      }
    },
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>
<style scoped>
.line_wrap {
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.08);
  z-index: 2;
  background: rgba(255, 255, 255, 0.8);
}
.HeadFixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.08);
  z-index: 2;
  background: #fff;
}
.wrap {
  min-width: 1200px;
  max-width: 1400px;
  margin: auto;
  display: flex;
  justify-content: space-between;
}
.logo {
  width: 370px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ivu-menu-horizontal.ivu-menu-light:after {
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue